module.exports = __webpack_public_path__ + "img/cp_01.b17b4312.png";